import { PogNonCircular } from "@CommonTypes/merchflow/pog/pog";

export const RouteGetMerchflows_merchflowId_S1_s1UserTriggerId_Templates_templateId_ =
  "/merchflows/:merchflowId/s1/:s1UserTriggerId/templates/:templateId";

export type ResponseGetMerchflows_merchflowId_S1_s1UserTriggerId_Templates_templateId_ = ({
  algo_request: unknown | null;
  algo_response: unknown | null;
  error: string | null;
} & (
  | {
      status: "NOT_STARTED" | "IN_PROGRESS" | "ERROR";
    }
  | {
      status: "DONE";
      s2_solution_id: number;
      solution: PogNonCircular;
    }
))[];
